import { useEffect } from 'react'
import { getDetailedFamilyTreeData } from '../services/services'
import useEP from './useEP'
import * as LocationHelper from '../helpers/location_Helper'

export const useDetailedFamilyTreeData = (generations) => {
  const [state, dispatch, fn] = useEP(getDetailedFamilyTreeData)
  useEffect(() => {
    if (generations) {
      dispatch({ type: 'load' })
    }
  }, [dispatch, generations])

  useEffect(() => {
    if (state.load) {
      getDetailedFamilyTreeData(generations).then((res) => {
        dispatch({ type: 'complete', res })
      })
    }
  }, [dispatch, generations, state.load])

  useEffect(() => {
    if (state.complete) {
      const workingTree = []
      const locationLookup = state.res.placesLookup
      state.res.persons.forEach((curPerson) => {
        const expandedPerson = LocationHelper.expandPerson({
          person: curPerson,
          locationLookup,
          tree: state.res.persons,
        })

        workingTree.push(expandedPerson)
      })

      state.res.persons = workingTree
    }
  }, [dispatch, generations, state.complete, state.res])

  return [state, fn, dispatch]
}
export const dummy = {}
